import { Serializer, UISerializableLiquidationRecord } from '@drift/common';
import { useComposedHistory } from './useComposedHistory';
import {
	ALWAYS_TRUE_FILTER,
	type HistoryTableUIProps,
} from './historyDataTypes';

export const useLiquidationsHistory =
	(): HistoryTableUIProps<UISerializableLiquidationRecord> => {
		const { historyData, executePageChange } = useComposedHistory(
			'liquidations',
			Serializer.Deserialize.DataApiUILiquidation
		);

		return {
			executePageChange,
			filterFn: ALWAYS_TRUE_FILTER,
			historyData,
		};
	};
